const translations = {
  title: 'Actividades Dinámicas',
  name: 'Nombre',
  checklist: 'Cuestionario',
  place: 'Destino',
  cardsView: 'Vista de tarjetas (próximamente)',
  selectPlace: 'Seleccione un destino',
  lockReasons: 'Motivos de bloqueo',
  successTitle: '¡Actividad respondida con éxito!',
  successBody: '¡Las respuestas ya han sido enviadas!'
}

export default translations
